import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'so0020',
    ecrans: ['00-2'],
    params: ['tuncleint',
             'tundatvig']
});
